import { useEffect } from 'react';
import { Button, Result } from 'antd';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { logger } from '@/utils/logger';

const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    logger.error('Route error captured', error);
  }, [error]);

  const message = isRouteErrorResponse(error)
    ? error.statusText || '页面访问失败'
    : error instanceof Error
      ? error.message
      : '页面加载失败';

  return (
    <Result
      extra={
        <Button onClick={() => navigate('/home')} type="primary">
          返回首页
        </Button>
      }
      status="error"
      subTitle={message}
      title="路由加载异常"
    />
  );
};

export default RouteErrorBoundary;
